/**
 * The FAQs for `/tools/character-counter`, in their own module so the route's
 * `head` can emit them as `FAQPage` JSON-LD without importing the tool
 * component into the entry chunk (see `thread-splitter-faqs.ts`).
 */
export const CHARACTER_COUNTER_FAQS = [
  {
    q: "What is the character limit on X (Twitter)?",
    a: "280 for a standard account, but X does not count every character as one. Any link counts as 23 however long it is, and emoji and most Chinese, Japanese and Korean characters count as 2. That is why a post can look short and still be rejected; this counter applies X's own weighting.",
  },
  {
    q: "What is the Bluesky character limit?",
    a: "300, counted as graphemes: what you see as one character is one, so a flag or a skin-toned emoji counts once even though it is several code points. Bluesky also caps a post at 3,000 bytes, which only matters for very emoji-heavy or non-Latin text.",
  },
  {
    q: "How long can an Instagram caption be?",
    a: "2,200 characters. Instagram also announced in December 2025 that a post or Reel takes 5 hashtags, while its API documentation still says 30, so this counter warns you past 5 rather than blocking the draft.",
  },
  {
    q: "What are the Threads, TikTok and Facebook limits?",
    a: "Threads allows 500 characters per post, TikTok 2,200 for a caption, and Facebook 63,206 for a Page post. Each counts characters as written, with no special weighting for links.",
  },
  {
    q: "Is the Mastodon limit really 500?",
    a: "500 is Mastodon's default, and many servers raise it. Mastodon counts every link as 23 and ignores the server part of a mention. Use the Mastodon limit checker to read your own server's real limit.",
  },
  {
    q: "Is what I type stored or sent anywhere?",
    a: "No. Everything is counted in your browser, and the text never leaves the page. The counts use the same code PostDaily's composer uses, so a draft that fits here will be accepted when you schedule it.",
  },
] as const;
